import React from 'react';
import { format } from 'date-fns';
import { toJsDate } from './dateUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFutbol, faHospital, faBookOpen, faShirt, faUtensils, faBaby, faCar, faFilm, faClipboardList } from '@fortawesome/free-solid-svg-icons';

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};

export const getVenmoDeepLink = (amount, note, recipient) => {
  const params = new URLSearchParams({
    txn: 'pay',
    amount: amount.toFixed(2),
    note: note || 'CoParent expense'
  });
  if (recipient) params.set('recipients', recipient);
  return `venmo://paycharge?${params.toString()}`;
};

export const getPaypalLink = (amount, recipient) => {
  if (recipient) {
    return `https://paypal.me/${recipient}/${amount.toFixed(2)}`;
  }
  return null;
};

export const getCategoryIcon = (category) => {
  const icons = {
    activities: faFutbol,
    medical: faHospital,
    school: faBookOpen,
    clothing: faShirt,
    food: faUtensils,
    childcare: faBaby,
    transportation: faCar,
    entertainment: faFilm,
    other: faClipboardList
  };
  return <FontAwesomeIcon icon={icons[category] || faClipboardList} />;
};

export const groupExpensesByMonth = (expenses) => {
  const grouped = {};
  expenses.forEach(expense => {
    const date = toJsDate(expense.date);
    const monthKey = format(date, 'yyyy-MM');
    const monthLabel = format(date, 'MMMM yyyy');
    if (!grouped[monthKey]) {
      grouped[monthKey] = { label: monthLabel, expenses: [], total: 0 };
    }
    grouped[monthKey].expenses.push(expense);
    grouped[monthKey].total += expense.amount;
  });
  return grouped;
};
